import {ProductInterface as CatalogProductInterface} from "../interfaces/catalog/ProductInterface";
import {useContext} from "react";
import {ReducerStateInterface} from "../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../GlobalReducer";
import {ProductInterface} from "../interfaces/product/ProductInterface";
import {BasketItemInterface} from "../interfaces/checkout/BasketItemInterface";

export default function useBasket(product: CatalogProductInterface | ProductInterface) {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const inBasket = () => {
        return state.basket?.map((item: BasketItemInterface) => item.product.id).includes(product?.id) || false;
    }

    const getQuantity = () => {
        const basketItem = state.basket?.find((item: BasketItemInterface) => item.product.id === product?.id);
        return basketItem?.quantity || 1;
    }

    const addToBasket = () => {
        dispatch({type: ReducerActionType.ADD_TO_BASKET, payload: product});
    }

    const removeFromBasket = () => {
        dispatch({type: ReducerActionType.REMOVE_FROM_BASKET, payload: product});
    }

    const updateQuantity = (quantity: number) => {
        dispatch({
            type: ReducerActionType.UPDATE_BASKET_QUANTITY,
            payload: { productId: product.id, quantity }
        });
    }

    return {inBasket, addToBasket, removeFromBasket, getQuantity, updateQuantity}
}